import React, { useState, useEffect } from 'react';
import Footerdiv from "../layout/footer.js";
import Headerdiv from "../layout/header.js";
import {
  Layout,
  Typography,
  Descriptions,
  Card,
  Button,
  Space,
  Breadcrumb,
  Spin,
  Tag,
  Divider,
  Row,
  Col,
  theme,
  Modal
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { MAINAPIURL, APPBACKGROUND_COLOR, COMPANYLOGO } from '../appsettings.js';
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { Page, Text, View, Document, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Table, TR, TH, TD } from '@ag-media/react-pdf-table';
import { Link } from 'react-router-dom';
import printlogo from '../printpropertise/printlogoceylonika.png';
import Html from 'react-pdf-html';

const { Title } = Typography;
const { Content } = Layout;

const GrnPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const UPDATED_BY = localStorage.getItem("USERID");

  const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

  const [purchaseOrder, setPurchaseOrder] = useState(null);
  const [poItems, setPoItems] = useState([]);
  const [grn, setGrn] = useState(null);
  const [grnItems, setGrnItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLoading, setItemsLoading] = useState(true);

  // Format date helper function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (e) {
      return dateString;
    }
  };
  const styles = StyleSheet.create({
    page: {
      padding: 20,
      fontSize: 10,
      fontFamily: 'Helvetica',

    },
    row: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 },
    logo: { width: 150, height: 50 },
    companyInfo: { marginLeft: 10 },
    sectionBox: {
      // border: '1 solid #000',
      borderRadius: 5,
      marginBottom: 5,
      width: '48%',
      backgroundColor: '#edfcfc',
    },
    sectionBoxHeader: {
      borderRadius: 5,
      padding: 10,
      backgroundColor: '#a0fae8',
    },
    sectionBoxContent: {
      padding: 10,
    },
    table: {
      border: '1 solid #a0fae8',
      marginVertical: 10,
    },
    tableHeader: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid ',
      backgroundColor: '#a0fae8',
      fontWeight: 'bold',
    },
    tableRow: {
      padding: 5,
      flexDirection: 'row',
      borderBottom: '1 solid white',
      backgroundColor: '#edfcfc',
    },
    cell: { flex: 1, padding: 3 },
    centeredCell: { flex: 1, padding: 2, textAlign: 'center' },
    leftCell: { flex: 1, padding: 2, textAlign: 'left', width: "20%" },
    rightCell: { flex: 1, padding: 2, textAlign: 'right' },
    noteTaxRow: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 10 },
    signatureSection: { marginTop: 30, flexDirection: 'row', justifyContent: 'space-between' },
    footer: {
      position: 'absolute', margin: '0 10', bottom: 10, left: 0, right: 0, textAlign: 'center', fontSize: 9, borderTop: '1 solid #c3c3c3', padding: 5,
    },
  });
  useEffect(() => {
    const fetchPurchaseOrderDetails = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${ApiURL}/grn/getgrnheaderdetails/${id}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (response.data) {
          setGrn(response.data);
        } else {
          AlertError('Failed to load Goods Receive data');
        }
      } catch (error) {

        AlertError('Error loading Goods Receive details');
      } finally {
        setLoading(false);
      }
    };

    const fetchPurchaseOrderItems = async () => {
      setItemsLoading(true);
      try {
        const response = await axios.get(`${ApiURL}/grn/getgrnitemdetails/${id}`, {
          headers: { SystemAccessToken: TOKEN }
        });

        if (response.data) {
          setGrnItems(Array.isArray(response.data) ? response.data : []);
        } else {
          AlertError('Failed to load Goods Receive items');
        }
      } catch (error) {

        AlertError('Error loading Goods Receive items');
      } finally {
        setItemsLoading(false);
      }
    };

    if (id) {
      fetchPurchaseOrderDetails();
      fetchPurchaseOrderItems();
    }
  }, [id, ApiURL, TOKEN]);


  return (
    <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
      <Headerdiv />
      <Content style={{ padding: '10px' }}>

        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item><Link to="/grnlist">Goods Receives</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Goods Receive Print</Breadcrumb.Item>
        </Breadcrumb>



        <div style={{ padding: 20, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG }}>
          <Space direction="vertical" style={{ width: "100%", padding: "15px" }}>

            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16 }}>Loading goods receive details...</div>
              </div>
            ) : grn ? (
              <>
                <PDFViewer width={"100%"} height={"500px"}>
                  <Document title={`PO-${grn.grnReferance}`} subject={`PO-${grn.grnReferance}`}>
                    <Page size="A4" style={styles.page} wrap>

                      <View style={styles.row}>
                        <View style={{ flexDirection: 'column', flex: 1 }}>
                          <Image src={printlogo} style={styles.logo} />
                          <View style={styles.companyInfo}>
                            <Text>Ceylonika Cosmetics (Pvt) Ltd</Text>
                            <Text>154/11, Pushparama Road, Kadawatha</Text>
                            <Text>www.ceylonikacosmetics.com | info@ceylonikacosmetics.com</Text>
                            <Text>+94 112 92 44 20</Text>
                          </View>
                        </View>

                        <View style={{ textAlign: 'right' }}>
                          <Text style={{ fontSize: 16, fontWeight: 'bold', paddingBottom: 5 }}>GOODS RECEIVE NOTE</Text>
                          <Text>GRN Reference : {grn.grnReferance || '#xxxxxxx'}</Text>
                          {/* <Text>PO Reference    : {grn.poReferance || '#xxxxxxx'}</Text> */}
                          <Text>GRN Date : {formatDate(grn.createdDate) || '__/__/20__'}</Text>
                          <Text>Created By : {grn.createdBy || '--'}</Text>
                          <Text>Target Stock: {grn.stockName || ''}</Text>
                          <Text>GRN Status : {grn.currentStage || '--'}</Text>
                        </View>
                      </View>


                      <View style={styles.row}>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Vendor Details</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Text>PO Ref. No: {grn.poReferance || ''}</Text>
                            <Text>Name: {grn.vendorName || ''}</Text>
                            <Text>Ref. No: {grn.vendorBillNo || ''}</Text>
                            <Text>Ref. Date: {formatDate(grn.vendorBillDate) || ''}</Text>
                          </View>

                        </View>
                        {/* <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>PO Reference</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                         
                          
                          </View>


                        </View> */}
                      </View>


                      <View style={styles.table}>
                        <View style={styles.tableHeader}>
                          <Text style={styles.leftCell} width={"10%"}>Code</Text>
                          <Text style={styles.leftCell} width={"50%"}>Item</Text>
                          <Text style={styles.rightCell} width={"10%"}>Qty</Text>
                          <Text style={styles.rightCell} width={"15%"}>Cost Price</Text>
                          <Text style={styles.rightCell} width={"15%"}>Total Price</Text>
                        </View>
                        {grnItems.map((item, index) => (
                          <View style={styles.tableRow} key={index}>
                            <Text style={styles.leftCell}>{item.itemSku}</Text>
                            <Text wrap={false} style={styles.leftCell}>{item.itemName}</Text>
                            <Text style={styles.rightCell}>{item.quantity}</Text>
                            <Text style={styles.rightCell}>{item.costPrice}</Text>
                            <Text style={styles.rightCell}>{item.totalCost}</Text>
                          </View>
                        ))}
                      </View>


                      <View style={styles.noteTaxRow}>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Special Note</Text>

                          </View>
                          <View style={styles.sectionBoxContent}>
                            <Html style={{ fontSize: "10px" }}>{grn.grnNote}</Html>
                          </View>
                        </View>
                        <View style={styles.sectionBox}>
                          <View style={styles.sectionBoxHeader}>
                            <Text style={{ fontWeight: 'bold' }}>Final Summary</Text>
                          </View>
                          <View style={styles.sectionBoxContent}>
                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                              <View>
                                <Text style={{ padding: '5' }} >Total Products Cost :</Text>
                                <Text style={{ padding: '5' }} >Total Vat (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Taxes (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Discount (-) :</Text>
                                <Text style={{ padding: '5' }} >Total Local Shipping (+) :</Text>
                                <Text style={{ padding: '5' }} >Total Int. Shipping (+) :</Text>
                                <Text style={{ padding: '5', fontWeight: 'bold' }} >Final Amount :</Text>
                              </View>
                              <View style={{ alignItems: 'flex-end' }}>
                                <Text style={{ padding: '5' }} >{grn.totalProductCost || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{grn.totalVat || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{grn.totalTax || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{grn.totalDiscount || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{grn.totalShippingLocal || '0.00'}</Text>
                                <Text style={{ padding: '5' }} >{grn.totalShippingInt || '0.00'}</Text>
                                <Text style={{ padding: '5', fontWeight: 'bold' }} >{grn.totalPayable || '0.00'}</Text>
                              </View>
                            </View>
                          </View>
                        </View>

                      </View>


                      <View style={styles.signatureSection}>
                        <Text>Date: ............../................../..................</Text>
                        <Text>Signature: ___________________________</Text>
                      </View>

                      {/* Footer */}
                      <View style={styles.footer}>
                        <Text render={({ pageNumber, totalPages }) => (
                          `Page ${pageNumber} / ${totalPages}`
                        )} fixed />
                      </View>


                    </Page>
                  </Document>
                </PDFViewer>

              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                <p>GRN not found</p>
              </div>
            )}

          </Space>
        </div>
      </Content>
      <Footerdiv />
    </Layout>
  );
};

export default GrnPrint;
